import { Apartment } from '../CommonTypes';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

const fetchApartments = async (company: string, site: string) => {
  if (process.env.NODE_ENV === 'development') console.log('fetching apartments', site, company);

  const colRef = collection(db, `${company}/${site}/apartments`);

  const results = await getDocs(colRef);

  return results.docs.map(doc => {
    const data = doc.data() as Omit<Apartment, 'id'>;
    return { ...data, id: doc.id } as Apartment;
  });
  // return results.docs.map((doc) => doc.data() as Apartment);
};

export default fetchApartments;
